import { render, staticRenderFns } from "./ThSortable.vue?vue&type=template&id=5e5bc2dc"
import script from "./ThSortable.vue?vue&type=script&lang=js"
export * from "./ThSortable.vue?vue&type=script&lang=js"
import style0 from "./ThSortable.vue?vue&type=style&index=0&id=5e5bc2dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports